import { render, staticRenderFns } from "./Programming.vue?vue&type=template&id=63c925b0"
import script from "./Programming.vue?vue&type=script&lang=js"
export * from "./Programming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports